import Vue from 'vue'
import VueCookies from 'vue-cookies'
import api from '../../api/leadRealAPI'
import router from '../../router'

Vue.use(VueCookies)

export default {
  namespaced: true,

  state: {
    articles: null,
    articleDetails: null,
    language: router.currentRoute.params.lang,
    articlesList: null
  },

  getters: {
    articles: state => state.articles,
    articleDetails: state => state.articleDetails,
    articlesList: state => state.articlesList
  },

  mutations: {
    setArticles (state, articles) {
      state.articles = articles
    },
    setArticleDetails (state, articleDetails) {
      state.articleDetails = articleDetails
    },
    setArticlesList (state, articlesList) {
      state.articlesList = articlesList
    }
  },

  actions: {
    getArticles ({ commit }, language) {
      var languages = { language: router.currentRoute.params.lang }
      api
        .get('/member/blogList/')
        .then(response => {
          const articleList = response.data.data
          const articles = []
          switch (router.currentRoute.params.lang) {
            case 'ja':
              articles.push(articleList.filter(value => value.blog_categories.name_ja === 'published'))
              break
            case 'en':
              articles.push(articleList.filter(value => value.blog_categories.name_en === 'published'))
              break
            case 'zh-cn':
              articles.push(articleList.filter(value => value.blog_categories['name_zh-cn'] === 'published'))
              break
            case 'zh-tw':
              articles.push(articleList.filter(value => value.blog_categories['name_zh-tw'] === 'published'))
              break
          }
          const dashboardValue = []
          const articled = articles[0]
          // const article = []
          switch (language) {
            case 'ja':
              language = 'name_ja'
              break
            case 'en':
              language = 'name_en'
              break
            case 'zh-cn':
              language = 'name_zh-cn'
              break
            case 'zh-tw':
              language = 'name_zh-tw'
              break
          }

          Object.entries(articled).forEach(([key, element]) => {
            var articleDetails = element.blog_articles_details.filter(value => value.language === 'name_' + languages.language)
            articled[key].blog_articles_details = articleDetails
            if (dashboardValue.length < 3) {
              dashboardValue.push(articled[key])
            }
          })

          commit('setArticlesList', dashboardValue)
          commit('setArticles', articled)
        })
        .catch(() => {})
    },
    getArticleDetails ({ commit }, data) {
      api
        .get('/member/specificBlog/' + data.id)
        .then(response => {
          if (response.data.data.blog_categories['name_' + router.currentRoute.params.lang] === 'published') {
            commit('setArticleDetails', response.data.data)
          } else {
            router.push({ name: 'Client 404', params: { lang: router.currentRoute.params.lang } })
          }
        })
        .catch(() => {})
    }
  }
}
